import React, { FC } from "react";
import { FinancialInfoFields } from "../clientAllFields";
import { Grid } from "@mui/material";
import FormField from "../../../../components/common/FormField";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setNewClientLocal } from "../../../../store/reducers/adminClientsSlice";
interface ManageFinancialInfoProps {
  selectClient: any; // Adjust type as per your requirement,
  finanicalError: any;
  formData?: any;
  setFormData?: any;
  checkValidator?: any;
  resetValidator?: any;
}
const FinancialInfoForm: FC<ManageFinancialInfoProps> = ({
  selectClient,
  finanicalError,
  formData,
  setFormData,
  checkValidator,
  resetValidator
}) => {

  const dispatch = useDispatch();
  const { newClientLocal } = useSelector((state: any) => state?.adminClients);

  const onChangeAction = (event: any) => {
    const { id, value } = event.target;
    let transformedValue: string | number = value;

    // Check specific fields to convert to number
    // if (id === "extendedLiabilityPercent" || id === "extendedLiabilityTax" || id === "insuranceFixedRate" ) {
    //   // Check if value is numeric (allow empty input as well)
    //   if (/^\d*$/.test(value)) {
    //     transformedValue = parseInt(value, 10); // Parse to integer
    //   } else {
    //     transformedValue = ''; // Or handle non-numeric input as needed
    //   }
    // }

    dispatch(
      setNewClientLocal({
        // ...newClientLocal,
        financialInformation: {
          ...newClientLocal?.financialInformation,
          [id]: transformedValue,
          ...(id === 'isSameWithCompanyAddress' && transformedValue) && {invoiceAddress: newClientLocal?.companyProfile?.address}
        },
      })
    );
    setFormData((prevValues: any) => ({ ...prevValues, [id]: transformedValue }));
    resetValidator(event.target.id)
    if((id === 'isSameWithCompanyAddress' && newClientLocal?.financialInformation?.invoiceAddress) || (id === 'isSameWithCompanyAddress' && transformedValue)){
      resetValidator('invoiceAddress')
    }
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };
 

  return (
    <>
      {FinancialInfoFields?.map((field, i) => {
        return (
          !selectClient && (
            <Grid container spacing={2} key={i}>
              <FormField
                onPaste={(e)=>e.preventDefault()}
                onKeyDown={(event:any) => {
                  console.log('event log-',event, event.target.value + event.key)
                  if(
                    event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 37 ||
                    event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 40 ||
                    event.keyCode === 18 || event.keyCode === 17 ||
                    event.ctrlKey
                  ) return event  
                  if(field?.patternAllowed && (!field?.patternAllowed.test(event.key))){
                    event.preventDefault();
                  } else if(field?.patternAllowed && (!field?.patternAllowed.test(event.target.value + event.key))){
                    event.preventDefault();
                  }
                }}
                {...{
                  ...field,
                  value: newClientLocal?.financialInformation ? newClientLocal?.financialInformation[field?.id] : '',
                  ...{
                    variant: "outlined", // Adding this variant prop
                    onChange: onChangeAction,
                    onBlur: onBlurAction,
                    ...{...field?.type === 'checkbox' && {checked: newClientLocal?.financialInformation && newClientLocal?.financialInformation[field?.id]}},
                    InputProps: {
                      ...(newClientLocal?.financialInformation['isSameWithCompanyAddress'] && field?.id === 'invoiceAddress') && {disabled: true},
                      sx:
                        field?.type === "text"
                          ? { height: "36px" }
                          : { padding: "10px 4px", height: "36px" },
                    },
                    error: finanicalError && finanicalError[field?.id],
                    // helperText: finanicalError && finanicalError[field?.id],
                  },
                }}
              />
            </Grid>
          )
        );
      })}
    </>
  );
};
export default FinancialInfoForm;
